/**
 * Provider Dashboard Page
 *
 * Main dashboard container that wraps all provider routes with the dashboard layout.
 * Uses Outlet to render child routes (jobs, bids, resources, etc.).
 */

import { Outlet, useNavigate } from 'react-router-dom';
import { DashboardLayout } from '@/components/service-provider/DashboardLayout';
import { createNavigationSections } from '@/components/service-provider/navigation-config';
import { useAuth } from '@/contexts/AuthContext';

export function ProviderDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // Create navigation sections
  const navigationSections = createNavigationSections();

  // Create user profile view model from auth context
  const userProfile = {
    name: user?.email?.split('@')[0] || 'User',
    email: user?.email || '',
    company: 'Service Provider', // TODO: Get from provider profile when available
    avatarUrl: undefined,
    onProfileClick: () => navigate('/provider/dashboard/settings'),
    onLogout: () => {
      logout();
      navigate('/provider/login');
    },
  };

  return (
    <DashboardLayout
      navigationSections={navigationSections}
      userProfile={userProfile}
    >
      <Outlet />
    </DashboardLayout>
  );
}
